/* @generated */
// prettier-ignore
if (Intl.NumberFormat && typeof Intl.NumberFormat.__addLocaleData === 'function') {
  Intl.NumberFormat.__addLocaleData({
  "data": {
    "currencies": {
      "ADP": {
        "displayName": {
          "other": "ანდორული პესეტა"
        },
        "narrow": "ADP",
        "symbol": "ADP"
      },
      "AED": {
        "displayName": {
          "other": "არაბთა გაერთიანებული საამიროების დირჰამი"
        },
        "narrow": "AED",
        "symbol": "AED"
      },
      "AFA": {
        "displayName": {
          "other": "ავღანი (1927–2002)"
        },
        "narrow": "AFA",
        "symbol": "AFA"
      },
      "AFN": {
        "displayName": {
          "other": "ავღანური ავღანი"
        },
        "narrow": "؋",
        "symbol": "AFN"
      },
      "ALL": {
        "displayName": {
          "other": "ალბანური ლეკი"
        },
        "narrow": "ALL",
        "symbol": "ALL"
      },
      "AMD": {
        "displayName": {
          "other": "სომხური დრამი"
        },
        "narrow": "֏",
        "symbol": "AMD"
      },
      "ANG": {
        "displayName": {
          "other": "ნიდრელანდების ანტილიის გულდენი"
        },
        "narrow": "ANG",
        "symbol": "ANG"
      },
      "AOA": {
        "displayName": {
          "other": "ანგოლური კვანზა"
        },
        "narrow": "Kz",
        "symbol": "AOA"
      },
      "AOK": {
        "displayName": {
          "other": "ანგოლური კვანზა (1977–1990)"
        },
        "narrow": "AOK",
        "symbol": "AOK"
      },
      "AON": {
        "displayName": {
          "other": "ანგოლური ახალი კვანზა (1990–2000)"
        },
        "narrow": "AON",
        "symbol": "AON"
      },
      "AOR": {
        "displayName": {
          "other": "ანგოლური მიტოლებული კვანზა (1995–1999)"
        },
        "narrow": "AOR",
        "symbol": "AOR"
      },
      "ARA": {
        "displayName": {
          "other": "არგენტინული აუსტრალი"
        },
        "narrow": "ARA",
        "symbol": "ARA"
      },
      "ARP": {
        "displayName": {
          "other": "არგენტინული პესო (1983–1985)"
        },
        "narrow": "ARP",
        "symbol": "ARP"
      },
      "ARS": {
        "displayName": {
          "other": "არგენტინული პესო"
        },
        "narrow": "$",
        "symbol": "ARS"
      },
      "ATS": {
        "displayName": {
          "other": "ავსტრიული შილინგი"
        },
        "narrow": "ATS",
        "symbol": "ATS"
      },
      "AUD": {
        "displayName": {
          "other": "ავსტრალიური დოლარი"
        },
        "narrow": "$",
        "symbol": "AUD"
      },
      "AWG": {
        "displayName": {
          "other": "არუბანული გულდენი"
        },
        "narrow": "AWG",
        "symbol": "AWG"
      },
      "AZM": {
        "displayName": {
          "other": "აზერბაიჯანული მანათი (1993–2006)"
        },
        "narrow": "AZM",
        "symbol": "AZM"
      },
      "AZN": {
        "displayName": {
          "other": "აზერბაიჯანული მანათი"
        },
        "narrow": "₼",
        "symbol": "AZN"
      },
      "BAD": {
        "displayName": {
          "other": "ბოსნია-ჰერცოგოვინას დინარი"
        },
        "narrow": "BAD",
        "symbol": "BAD"
      },
      "BAM": {
        "displayName": {
          "other": "ბოსნია და ჰერცოგოვინას კონვერტირებადი მარკა"
        },
        "narrow": "KM",
        "symbol": "BAM"
      },
      "BBD": {
        "displayName": {
          "other": "ბარბადოსული დოლარი"
        },
        "narrow": "$",
        "symbol": "BBD"
      },
      "BDT": {
        "displayName": {
          "other": "ბანგლადეშური ტაკა"
        },
        "narrow": "৳",
        "symbol": "BDT"
      },
      "BEC": {
        "displayName": {
          "other": "ბელგიური ფრანკი (კოვერტირებადი)"
        },
        "narrow": "BEC",
        "symbol": "BEC"
      },
      "BEF": {
        "displayName": {
          "other": "ბელგიური ფრანკი"
        },
        "narrow": "BEF",
        "symbol": "BEF"
      },
      "BEL": {
        "displayName": {
          "other": "ბელგიური ფრანკი (ფინანსური)"
        },
        "narrow": "BEL",
        "symbol": "BEL"
      },
      "BGL": {
        "displayName": {
          "other": "ბულგარული მყარი ლევი"
        },
        "narrow": "BGL",
        "symbol": "BGL"
      },
      "BGN": {
        "displayName": {
          "other": "ბულგარული ლევი"
        },
        "narrow": "BGN",
        "symbol": "BGN"
      },
      "BHD": {
        "displayName": {
          "other": "ბაჰრეინული დინარი"
        },
        "narrow": "BHD",
        "symbol": "BHD"
      },
      "BIF": {
        "displayName": {
          "other": "ბურუნდიული ფრანკი"
        },
        "narrow": "BIF",
        "symbol": "BIF"
      },
      "BMD": {
        "displayName": {
          "other": "ბერმუდული დოლარი"
        },
        "narrow": "$",
        "symbol": "BMD"
      },
      "BND": {
        "displayName": {
          "other": "ბრუნეული დოლარი"
        },
        "narrow": "$",
        "symbol": "BND"
      },
      "BOB": {
        "displayName": {
          "other": "ბოლივიური ბოლივიანო"
        },
        "narrow": "Bs",
        "symbol": "BOB"
      },
      "BOP": {
        "displayName": {
          "other": "ბოლივიური პესო"
        },
        "narrow": "BOP",
        "symbol": "BOP"
      },
      "BRB": {
        "displayName": {
          "other": "ბრაზილიური კრუზეირო ნოვო (1967–1986)"
        },
        "narrow": "BRB",
        "symbol": "BRB"
      },
      "BRC": {
        "displayName": {
          "other": "ბრაზილიური კრუზადო"
        },
        "narrow": "BRC",
        "symbol": "BRC"
      },
      "BRE": {
        "displayName": {
          "other": "ბრაზილიური კრუზეირო (1990–1993)"
        },
        "narrow": "BRE",
        "symbol": "BRE"
      },
      "BRL": {
        "displayName": {
          "other": "ბრაზილიური რეალი"
        },
        "narrow": "R$",
        "symbol": "R$"
      },
      "BRN": {
        "displayName": {
          "other": "ბრაზილიური კრუზადო ნოვო"
        },
        "narrow": "BRN",
        "symbol": "BRN"
      },
      "BRR": {
        "displayName": {
          "other": "ბრაზილიური კრუზეირო"
        },
        "narrow": "BRR",
        "symbol": "BRR"
      },
      "BSD": {
        "displayName": {
          "other": "ბაჰამური დოლარი"
        },
        "narrow": "$",
        "symbol": "BSD"
      },
      "BTN": {
        "displayName": {
          "other": "ბუტანური ნგულტრუმი"
        },
        "narrow": "BTN",
        "symbol": "BTN"
      },
      "BWP": {
        "displayName": {
          "other": "ბოცვანური პულა"
        },
        "narrow": "P",
        "symbol": "BWP"
      },
      "BYB": {
        "displayName": {
          "other": "ახალი ბელარუსიული რუბლი (1994–1999)"
        },
        "narrow": "BYB",
        "symbol": "BYB"
      },
      "BYN": {
        "displayName": {
          "other": "ბელორუსული რუბლი"
        },
        "narrow": "р.",
        "symbol": "BYN"
      },
      "BYR": {
        "displayName": {
          "other": "ბელორუსული რუბლი (2000–2016)"
        },
        "narrow": "BYR",
        "symbol": "BYR"
      },
      "BZD": {
        "displayName": {
          "other": "ბელიზის დოლარი"
        },
        "narrow": "$",
        "symbol": "BZD"
      },
      "CAD": {
        "displayName": {
          "other": "კანადური დოლარი"
        },
        "narrow": "$",
        "symbol": "CA$"
      },
      "CDF": {
        "displayName": {
          "other": "კონგოს ფრანკი"
        },
        "narrow": "CDF",
        "symbol": "CDF"
      },
      "CHF": {
        "displayName": {
          "other": "შვეიცარიული ფრანკი"
        },
        "narrow": "CHF",
        "symbol": "CHF"
      },
      "CLP": {
        "displayName": {
          "other": "ჩილეს პესო"
        },
        "narrow": "$",
        "symbol": "CLP"
      },
      "CNH": {
        "displayName": {
          "other": "ჩინური იუანი (ოფშორი)"
        },
        "narrow": "CNH",
        "symbol": "CNH"
      },
      "CNY": {
        "displayName": {
          "other": "ჩინური უანი"
        },
        "narrow": "¥",
        "symbol": "CNY"
      },
      "COP": {
        "displayName": {
          "other": "კოლუმბიური პესო"
        },
        "narrow": "$",
        "symbol": "COP"
      },
      "CRC": {
        "displayName": {
          "one": "კოსტა-რიკული კოლონი",
          "other": "კოსტა რიკული კოლონი"
        },
        "narrow": "₡",
        "symbol": "CRC"
      },
      "CSD": {
        "displayName": {
          "other": "ძველი სერბიული დინარი"
        },
        "narrow": "CSD",
        "symbol": "CSD"
      },
      "CSK": {
        "displayName": {
          "other": "ჩეხოსლოვაკიის მყარი კრონა"
        },
        "narrow": "CSK",
        "symbol": "CSK"
      },
      "CUC": {
        "displayName": {
          "other": "კუბური კონვერტირებადი პესო"
        },
        "narrow": "$",
        "symbol": "CUC"
      },
      "CUP": {
        "displayName": {
          "other": "კუბური პესო"
        },
        "narrow": "$",
        "symbol": "CUP"
      },
      "CVE": {
        "displayName": {
          "other": "კაბო-ვერდეს ესკუდო"
        },
        "narrow": "CVE",
        "symbol": "CVE"
      },
      "CYP": {
        "displayName": {
          "other": "კვიპროსის გირვანქა"
        },
        "narrow": "CYP",
        "symbol": "CYP"
      },
      "CZK": {
        "displayName": {
          "other": "ჩეხური კრონა"
        },
        "narrow": "Kč",
        "symbol": "CZK"
      },
      "DDM": {
        "displayName": {
          "other": "აღმოსავლეთ გერმანული მარკა"
        },
        "narrow": "DDM",
        "symbol": "DDM"
      },
      "DEM": {
        "displayName": {
          "other": "გერმანული მარკა"
        },
        "narrow": "DEM",
        "symbol": "DEM"
      },
      "DJF": {
        "displayName": {
          "other": "ჯიბუტის ფრანკი"
        },
        "narrow": "DJF",
        "symbol": "DJF"
      },
      "DKK": {
        "displayName": {
          "other": "დანიური კრონა"
        },
        "narrow": "kr",
        "symbol": "DKK"
      },
      "DOP": {
        "displayName": {
          "other": "დომინიკური პესო"
        },
        "narrow": "$",
        "symbol": "DOP"
      },
      "DZD": {
        "displayName": {
          "other": "ალჟირული დინარი"
        },
        "narrow": "DZD",
        "symbol": "DZD"
      },
      "EEK": {
        "displayName": {
          "other": "ესტონური კრუნა"
        },
        "narrow": "EEK",
        "symbol": "EEK"
      },
      "EGP": {
        "displayName": {
          "other": "ეგვიპტური გირვანქა"
        },
        "narrow": "E£",
        "symbol": "EGP"
      },
      "ERN": {
        "displayName": {
          "other": "ერიტრეის ნაკფა"
        },
        "narrow": "ERN",
        "symbol": "ERN"
      },
      "ESP": {
        "displayName": {
          "other": "ესპანური პესეტა"
        },
        "narrow": "₧",
        "symbol": "ESP"
      },
      "ETB": {
        "displayName": {
          "other": "ეთიოპიური ბირი"
        },
        "narrow": "ETB",
        "symbol": "ETB"
      },
      "EUR": {
        "displayName": {
          "other": "ევრო"
        },
        "narrow": "€",
        "symbol": "€"
      },
      "FIM": {
        "displayName": {
          "other": "ფინური მარკა"
        },
        "narrow": "FIM",
        "symbol": "FIM"
      },
      "FJD": {
        "displayName": {
          "other": "ფიჯის დოლარი"
        },
        "narrow": "$",
        "symbol": "FJD"
      },
      "FKP": {
        "displayName": {
          "other": "ფოლკლენდის კუნძულების ფუნტი"
        },
        "narrow": "£",
        "symbol": "FKP"
      },
      "FRF": {
        "displayName": {
          "other": "ფრანგული ფრანკი"
        },
        "narrow": "FRF",
        "symbol": "FRF"
      },
      "GBP": {
        "displayName": {
          "other": "ბრიტანული გირვანქა სტერლინგი"
        },
        "narrow": "£",
        "symbol": "£"
      },
      "GEK": {
        "displayName": {
          "other": "ქართული კუპონი ლარით"
        },
        "narrow": "GEK",
        "symbol": "GEK"
      },
      "GEL": {
        "displayName": {
          "other": "ქართული ლარი"
        },
        "narrow": "₾",
        "symbol": "₾"
      },
      "GHS": {
        "displayName": {
          "other": "განური სედი"
        },
        "narrow": "GH₵",
        "symbol": "GHS"
      },
      "GIP": {
        "displayName": {
          "other": "გიბრალტარული ფუნტი"
        },
        "narrow": "£",
        "symbol": "GIP"
      },
      "GMD": {
        "displayName": {
          "other": "გამბიური დალასი"
        },
        "narrow": "GMD",
        "symbol": "GMD"
      },
      "GNF": {
        "displayName": {
          "other": "გვინეური ფრანკი"
        },
        "narrow": "FG",
        "symbol": "GNF"
      },
      "GRD": {
        "displayName": {
          "other": "ბერძნული დრაჰმა"
        },
        "narrow": "GRD",
        "symbol": "GRD"
      },
      "GTQ": {
        "displayName": {
          "other": "გვატემალური კეტსალი"
        },
        "narrow": "Q",
        "symbol": "GTQ"
      },
      "GWE": {
        "displayName": {
          "other": "პორტუგალიური გინეა ესკუდო"
        },
        "narrow": "GWE",
        "symbol": "GWE"
      },
      "GYD": {
        "displayName": {
          "other": "გაიანური დოლარი"
        },
        "narrow": "$",
        "symbol": "GYD"
      },
      "HKD": {
        "displayName": {
          "other": "ჰონკონგის დოლარი"
        },
        "narrow": "$",
        "symbol": "HKD"
      },
      "HNL": {
        "displayName": {
          "other": "ჰონდურასული ლემპირა"
        },
        "narrow": "L",
        "symbol": "HNL"
      },
      "HRD": {
        "displayName": {
          "other": "ხორვატიული დინარი"
        },
        "narrow": "HRD",
        "symbol": "HRD"
      },
      "HRK": {
        "displayName": {
          "other": "ხორვატული კუნა"
        },
        "narrow": "kn",
        "symbol": "HRK"
      },
      "HTG": {
        "displayName": {
          "other": "ჰაიტური გურდი"
        },
        "narrow": "HTG",
        "symbol": "HTG"
      },
      "HUF": {
        "displayName": {
          "other": "უნგრული ფორინტი"
        },
        "narrow": "Ft",
        "symbol": "HUF"
      },
      "IDR": {
        "displayName": {
          "other": "ინდონეზიური რუპია"
        },
        "narrow": "Rp",
        "symbol": "IDR"
      },
      "IEP": {
        "displayName": {
          "other": "ირლანდიური გირვანქა"
        },
        "narrow": "IEP",
        "symbol": "IEP"
      },
      "ILS": {
        "displayName": {
          "other": "ისრაელის ახალი შეკელი"
        },
        "narrow": "₪",
        "symbol": "ILS"
      },
      "INR": {
        "displayName": {
          "other": "ინდური რუპია"
        },
        "narrow": "₹",
        "symbol": "INR"
      },
      "IQD": {
        "displayName": {
          "other": "ერაყული დინარი"
        },
        "narrow": "IQD",
        "symbol": "IQD"
      },
      "IRR": {
        "displayName": {
          "other": "ირანული რიალი"
        },
        "narrow": "IRR",
        "symbol": "IRR"
      },
      "ISK": {
        "displayName": {
          "other": "ისლანდიური კრონა"
        },
        "narrow": "kr",
        "symbol": "ISK"
      },
      "ITL": {
        "displayName": {
          "other": "იტალიური ლირა"
        },
        "narrow": "ITL",
        "symbol": "ITL"
      },
      "JMD": {
        "displayName": {
          "other": "იამაიკური დოლარი"
        },
        "narrow": "$",
        "symbol": "JMD"
      },
      "JOD": {
        "displayName": {
          "other": "იორდანიული დოლარი"
        },
        "narrow": "JOD",
        "symbol": "JOD"
      },
      "JPY": {
        "displayName": {
          "other": "იაპონური იენი"
        },
        "narrow": "¥",
        "symbol": "JPY"
      },
      "KES": {
        "displayName": {
          "other": "კენიური შილინგი"
        },
        "narrow": "KES",
        "symbol": "KES"
      },
      "KGS": {
        "displayName": {
          "other": "ყირგიზული სომი"
        },
        "narrow": "KGS",
        "symbol": "KGS"
      },
      "KHR": {
        "displayName": {
          "other": "კამბოჯური რიელი"
        },
        "narrow": "៛",
        "symbol": "KHR"
      },
      "KMF": {
        "displayName": {
          "other": "კომორული ფრანკი"
        },
        "narrow": "CF",
        "symbol": "KMF"
      },
      "KPW": {
        "displayName": {
          "other": "ჩრდილოეთ კორეული ვონი"
        },
        "narrow": "₩",
        "symbol": "KPW"
      },
      "KRW": {
        "displayName": {
          "other": "სამხრეთ კორეული ვონი"
        },
        "narrow": "₩",
        "symbol": "KRW"
      },
      "KWD": {
        "displayName": {
          "other": "ქუვეითური დინარი"
        },
        "narrow": "KWD",
        "symbol": "KWD"
      },
      "KYD": {
        "displayName": {
          "other": "კაიმანის კუნძულების დოლარი"
        },
        "narrow": "$",
        "symbol": "KYD"
      },
      "KZT": {
        "displayName": {
          "other": "ყაზახური ტენგე"
        },
        "narrow": "₸",
        "symbol": "KZT"
      },
      "LAK": {
        "displayName": {
          "other": "ლაოსური კიპი"
        },
        "narrow": "₭",
        "symbol": "LAK"
      },
      "LBP": {
        "displayName": {
          "other": "ლიბანური ფუნტი"
        },
        "narrow": "L£",
        "symbol": "LBP"
      },
      "LKR": {
        "displayName": {
          "other": "შრი-ლანკური რუპია"
        },
        "narrow": "Rs",
        "symbol": "LKR"
      },
      "LRD": {
        "displayName": {
          "other": "ლიბერიული დოლარი"
        },
        "narrow": "$",
        "symbol": "LRD"
      },
      "LSL": {
        "displayName": {
          "other": "ლესოთოს ლოტი"
        },
        "narrow": "LSL",
        "symbol": "LSL"
      },
      "LTL": {
        "displayName": {
          "other": "ლიტვური ლიტა"
        },
        "narrow": "Lt",
        "symbol": "LTL"
      },
      "LTT": {
        "displayName": {
          "other": "ლიტვური ტალონი"
        },
        "narrow": "LTT",
        "symbol": "LTT"
      },
      "LUC": {
        "displayName": {
          "other": "ლუქსემბურგის კონვერტირებადი ფრანკი"
        },
        "narrow": "LUC",
        "symbol": "LUC"
      },
      "LUF": {
        "displayName": {
          "other": "ლუქსემბურგის ფრანკი"
        },
        "narrow": "LUF",
        "symbol": "LUF"
      },
      "LUL": {
        "displayName": {
          "other": "ლუქსემბურგის ფინანსური ფრანკი"
        },
        "narrow": "LUL",
        "symbol": "LUL"
      },
      "LVL": {
        "displayName": {
          "other": "ლატვიური ლატი"
        },
        "narrow": "Ls",
        "symbol": "LVL"
      },
      "LVR": {
        "displayName": {
          "other": "ლატვიური რუბლი"
        },
        "narrow": "LVR",
        "symbol": "LVR"
      },
      "LYD": {
        "displayName": {
          "other": "ლიბიური დინარი"
        },
        "narrow": "LYD",
        "symbol": "LYD"
      },
      "MAD": {
        "displayName": {
          "other": "მაროკოს დირჰამი"
        },
        "narrow": "MAD",
        "symbol": "MAD"
      },
      "MAF": {
        "displayName": {
          "other": "მაროკოს ფრანკი"
        },
        "narrow": "MAF",
        "symbol": "MAF"
      },
      "MDL": {
        "displayName": {
          "other": "მოლდოვური ლეუ"
        },
        "narrow": "MDL",
        "symbol": "MDL"
      },
      "MGA": {
        "displayName": {
          "other": "მადაგასკარის არიარი"
        },
        "narrow": "Ar",
        "symbol": "MGA"
      },
      "MGF": {
        "displayName": {
          "other": "მადაგასკარის ფრანკი"
        },
        "narrow": "MGF",
        "symbol": "MGF"
      },
      "MKD": {
        "displayName": {
          "other": "მაკედონიური დინარი"
        },
        "narrow": "MKD",
        "symbol": "MKD"
      },
      "MLF": {
        "displayName": {
          "other": "მალის ფრანკი"
        },
        "narrow": "MLF",
        "symbol": "MLF"
      },
      "MMK": {
        "displayName": {
          "other": "მიანმარის კიატი"
        },
        "narrow": "K",
        "symbol": "MMK"
      },
      "MNT": {
        "displayName": {
          "other": "მონღოლური ტუგრიკი"
        },
        "narrow": "₮",
        "symbol": "MNT"
      },
      "MOP": {
        "displayName": {
          "other": "მაკაუს პატაკა"
        },
        "narrow": "MOP",
        "symbol": "MOP"
      },
      "MRO": {
        "displayName": {
          "other": "მავრიტანული უგია (1973–2017)"
        },
        "narrow": "MRO",
        "symbol": "MRO"
      },
      "MRU": {
        "displayName": {
          "other": "მავრიტანული უგია"
        },
        "narrow": "MRU",
        "symbol": "MRU"
      },
      "MTL": {
        "displayName": {
          "other": "მალტის ლირა"
        },
        "narrow": "MTL",
        "symbol": "MTL"
      },
      "MTP": {
        "displayName": {
          "other": "მალტის გირვანქა"
        },
        "narrow": "MTP",
        "symbol": "MTP"
      },
      "MUR": {
        "displayName": {
          "other": "მავრიტანული რუპია"
        },
        "narrow": "Rs",
        "symbol": "MUR"
      },
      "MVR": {
        "displayName": {
          "other": "მალდივური რუფია"
        },
        "narrow": "MVR",
        "symbol": "MVR"
      },
      "MWK": {
        "displayName": {
          "other": "მალავიური კვაჩა"
        },
        "narrow": "MWK",
        "symbol": "MWK"
      },
      "MXN": {
        "displayName": {
          "other": "მექსიკური პესო"
        },
        "narrow": "$",
        "symbol": "MX$"
      },
      "MXP": {
        "displayName": {
          "other": "მექსიკური ვერცხლის პესო (1861–1992)"
        },
        "narrow": "MXP",
        "symbol": "MXP"
      },
      "MYR": {
        "displayName": {
          "other": "მალაიზიური რინგიტი"
        },
        "narrow": "RM",
        "symbol": "MYR"
      },
      "MZE": {
        "displayName": {
          "other": "მოზამბიკური ესკუდო"
        },
        "narrow": "MZE",
        "symbol": "MZE"
      },
      "MZM": {
        "displayName": {
          "other": "ძველი მოზამბიკური მეტიკალი"
        },
        "narrow": "MZM",
        "symbol": "MZM"
      },
      "MZN": {
        "displayName": {
          "other": "მოზამბიკური მეტიკალი"
        },
        "narrow": "MZN",
        "symbol": "MZN"
      },
      "NAD": {
        "displayName": {
          "other": "ნამიბიური დოლარი"
        },
        "narrow": "$",
        "symbol": "NAD"
      },
      "NGN": {
        "displayName": {
          "other": "ნიგერიული ნაირა"
        },
        "narrow": "₦",
        "symbol": "NGN"
      },
      "NIC": {
        "displayName": {
          "other": "ნიკარაგუას კორდობა"
        },
        "narrow": "NIC",
        "symbol": "NIC"
      },
      "NIO": {
        "displayName": {
          "other": "ნიკარაგუას ოქროს კორდობა"
        },
        "narrow": "C$",
        "symbol": "NIO"
      },
      "NLG": {
        "displayName": {
          "other": "ჰოლანდიური გულდენი"
        },
        "narrow": "NLG",
        "symbol": "NLG"
      },
      "NOK": {
        "displayName": {
          "other": "ნორვეგიული კრონა"
        },
        "narrow": "kr",
        "symbol": "NOK"
      },
      "NPR": {
        "displayName": {
          "other": "ნეპალური რუპია"
        },
        "narrow": "Rs",
        "symbol": "NPR"
      },
      "NZD": {
        "displayName": {
          "other": "ახალი ზელანდიის დოლარი"
        },
        "narrow": "$",
        "symbol": "NZD"
      },
      "OMR": {
        "displayName": {
          "other": "ომანის რიალი"
        },
        "narrow": "OMR",
        "symbol": "OMR"
      },
      "PAB": {
        "displayName": {
          "other": "პანამური ბალბოა"
        },
        "narrow": "PAB",
        "symbol": "PAB"
      },
      "PEI": {
        "displayName": {
          "other": "პერუს ინტი"
        },
        "narrow": "PEI",
        "symbol": "PEI"
      },
      "PEN": {
        "displayName": {
          "other": "პერუს სოლი"
        },
        "narrow": "PEN",
        "symbol": "PEN"
      },
      "PES": {
        "displayName": {
          "other": "პერუს სოლი (1863–1965)"
        },
        "narrow": "PES",
        "symbol": "PES"
      },
      "PGK": {
        "displayName": {
          "other": "პაპუა-ახალი გვინეის კინა"
        },
        "narrow": "PGK",
        "symbol": "PGK"
      },
      "PHP": {
        "displayName": {
          "other": "ფილიპინური პესო"
        },
        "narrow": "₱",
        "symbol": "PHP"
      },
      "PKR": {
        "displayName": {
          "other": "პაკისტანური რუპია"
        },
        "narrow": "Rs",
        "symbol": "PKR"
      },
      "PLN": {
        "displayName": {
          "other": "პოლონური ზლოტი"
        },
        "narrow": "zł",
        "symbol": "PLN"
      },
      "PLZ": {
        "displayName": {
          "other": "პოლონური ზლოტი (1950–1995)"
        },
        "narrow": "PLZ",
        "symbol": "PLZ"
      },
      "PTE": {
        "displayName": {
          "other": "პორტუგალიური ესკუდო"
        },
        "narrow": "PTE",
        "symbol": "PTE"
      },
      "PYG": {
        "displayName": {
          "other": "პარაგვაული გუარანი"
        },
        "narrow": "₲",
        "symbol": "PYG"
      },
      "QAR": {
        "displayName": {
          "other": "კატარის რიალი"
        },
        "narrow": "QAR",
        "symbol": "QAR"
      },
      "RHD": {
        "displayName": {
          "other": "როდეზიული დოლარი"
        },
        "narrow": "RHD",
        "symbol": "RHD"
      },
      "ROL": {
        "displayName": {
          "other": "ძველი რუმინული ლეუ"
        },
        "narrow": "ROL",
        "symbol": "ROL"
      },
      "RON": {
        "displayName": {
          "other": "რუმინული ლეუ"
        },
        "narrow": "lei",
        "symbol": "RON"
      },
      "RSD": {
        "displayName": {
          "other": "სერბული დინარი"
        },
        "narrow": "RSD",
        "symbol": "RSD"
      },
      "RUB": {
        "displayName": {
          "other": "რუსული რუბლი"
        },
        "narrow": "₽",
        "symbol": "RUB"
      },
      "RUR": {
        "displayName": {
          "other": "რუსული რუბლი (1991–1998)"
        },
        "narrow": "RUR",
        "symbol": "RUR"
      },
      "RWF": {
        "displayName": {
          "other": "რუანდული ფრანკი"
        },
        "narrow": "RF",
        "symbol": "RWF"
      },
      "SAR": {
        "displayName": {
          "other": "საუდის არაბეთის რიალი"
        },
        "narrow": "SAR",
        "symbol": "SAR"
      },
      "SBD": {
        "displayName": {
          "other": "სოლომონის კუნძულების დოლარი"
        },
        "narrow": "$",
        "symbol": "SBD"
      },
      "SCR": {
        "displayName": {
          "other": "სეიშელური რუპია"
        },
        "narrow": "SCR",
        "symbol": "SCR"
      },
      "SDD": {
        "displayName": {
          "other": "სუდანის დინარი"
        },
        "narrow": "SDD",
        "symbol": "SDD"
      },
      "SDG": {
        "displayName": {
          "other": "სუდანური ფუნტი"
        },
        "narrow": "SDG",
        "symbol": "SDG"
      },
      "SDP": {
        "displayName": {
          "other": "სუდანის გირვანქა"
        },
        "narrow": "SDP",
        "symbol": "SDP"
      },
      "SEK": {
        "displayName": {
          "other": "შვედური კრონა"
        },
        "narrow": "kr",
        "symbol": "SEK"
      },
      "SGD": {
        "displayName": {
          "other": "სინგაპურის დოლარი"
        },
        "narrow": "$",
        "symbol": "SGD"
      },
      "SHP": {
        "displayName": {
          "other": "წმ. ელენეს კუნძულის ფუნტი"
        },
        "narrow": "£",
        "symbol": "SHP"
      },
      "SLL": {
        "displayName": {
          "other": "სიერა-ლეონეს ლეონე"
        },
        "narrow": "SLL",
        "symbol": "SLL"
      },
      "SOS": {
        "displayName": {
          "other": "სომალური შილინგი"
        },
        "narrow": "SOS",
        "symbol": "SOS"
      },
      "SRD": {
        "displayName": {
          "other": "სურინამული დოლარი"
        },
        "narrow": "$",
        "symbol": "SRD"
      },
      "SRG": {
        "displayName": {
          "other": "სურინამის გულდენი"
        },
        "narrow": "SRG",
        "symbol": "SRG"
      },
      "SSP": {
        "displayName": {
          "other": "სამხრეთ სუდანური ფუნტი"
        },
        "narrow": "£",
        "symbol": "SSP"
      },
      "STD": {
        "displayName": {
          "other": "სან-ტომე და პრინსიპის დობრა (1977–2017)"
        },
        "narrow": "STD",
        "symbol": "STD"
      },
      "STN": {
        "displayName": {
          "other": "სან-ტომე და პრინსიპის დობრა"
        },
        "narrow": "Db",
        "symbol": "STN"
      },
      "SUR": {
        "displayName": {
          "other": "საბჭოთა რუბლი"
        },
        "narrow": "SUR",
        "symbol": "SUR"
      },
      "SYP": {
        "displayName": {
          "other": "სირიული გირვანქა"
        },
        "narrow": "£",
        "symbol": "SYP"
      },
      "SZL": {
        "displayName": {
          "other": "სვაზილენდის ლილანგენი"
        },
        "narrow": "SZL",
        "symbol": "SZL"
      },
      "THB": {
        "displayName": {
          "other": "ტაილანდური ბატი"
        },
        "narrow": "฿",
        "symbol": "THB"
      },
      "TJR": {
        "displayName": {
          "other": "ტაჯიკური რუბლი"
        },
        "narrow": "TJR",
        "symbol": "TJR"
      },
      "TJS": {
        "displayName": {
          "other": "ტაჯიკური სომონი"
        },
        "narrow": "TJS",
        "symbol": "TJS"
      },
      "TMM": {
        "displayName": {
          "other": "თურქმენული მანათი"
        },
        "narrow": "TMM",
        "symbol": "TMM"
      },
      "TMT": {
        "displayName": {
          "other": "თურქმენეთის მანათი"
        },
        "narrow": "TMT",
        "symbol": "TMT"
      },
      "TND": {
        "displayName": {
          "other": "ტუნისის დინარი"
        },
        "narrow": "TND",
        "symbol": "TND"
      },
      "TOP": {
        "displayName": {
          "other": "ტონგანური პაანგა"
        },
        "narrow": "T$",
        "symbol": "TOP"
      },
      "TRL": {
        "displayName": {
          "other": "თურქული ლირა"
        },
        "narrow": "TRL",
        "symbol": "TRL"
      },
      "TRY": {
        "displayName": {
          "other": "ახალი თურქული ლირა"
        },
        "narrow": "₺",
        "symbol": "TRY"
      },
      "TTD": {
        "displayName": {
          "other": "ტრინიდად და ტობაგოს დოლარი"
        },
        "narrow": "$",
        "symbol": "TTD"
      },
      "TWD": {
        "displayName": {
          "other": "ტაივანური ახალი დოლარი"
        },
        "narrow": "NT$",
        "symbol": "NT$"
      },
      "TZS": {
        "displayName": {
          "other": "ტანზანიური შილინგი"
        },
        "narrow": "TZS",
        "symbol": "TZS"
      },
      "UAH": {
        "displayName": {
          "other": "უკრაინული გრივნა"
        },
        "narrow": "₴",
        "symbol": "UAH"
      },
      "UAK": {
        "displayName": {
          "other": "უკრაინული კარბოვანეცი"
        },
        "narrow": "UAK",
        "symbol": "UAK"
      },
      "UGS": {
        "displayName": {
          "other": "უგანდური შილინგი (1966–1987)"
        },
        "narrow": "UGS",
        "symbol": "UGS"
      },
      "UGX": {
        "displayName": {
          "other": "უგანდური შილინგი"
        },
        "narrow": "UGX",
        "symbol": "UGX"
      },
      "USD": {
        "displayName": {
          "other": "აშშ დოლარი"
        },
        "narrow": "$",
        "symbol": "US$"
      },
      "USN": {
        "displayName": {
          "other": "აშშ დოლარი (შემდეგი დღე)"
        },
        "narrow": "USN",
        "symbol": "USN"
      },
      "USS": {
        "displayName": {
          "other": "აშშ დოლარი (იგივე დღე)"
        },
        "narrow": "USS",
        "symbol": "USS"
      },
      "UYP": {
        "displayName": {
          "other": "ურუგვაის პესო (1975–1993)"
        },
        "narrow": "UYP",
        "symbol": "UYP"
      },
      "UYU": {
        "displayName": {
          "other": "ურუგვაის პესო"
        },
        "narrow": "$",
        "symbol": "UYU"
      },
      "UZS": {
        "displayName": {
          "other": "უზბეკური სუმი"
        },
        "narrow": "UZS",
        "symbol": "UZS"
      },
      "VEB": {
        "displayName": {
          "other": "ვენესუელის ბოლივარი (1871–2008)"
        },
        "narrow": "VEB",
        "symbol": "VEB"
      },
      "VEF": {
        "displayName": {
          "other": "ვენესუელის ბოლივარი (2008–2018)"
        },
        "narrow": "Bs",
        "symbol": "VEF"
      },
      "VES": {
        "displayName": {
          "other": "ვენესუელის ბოლივარი"
        },
        "narrow": "VES",
        "symbol": "VES"
      },
      "VND": {
        "displayName": {
          "other": "ვიეტნამური დონგი"
        },
        "narrow": "₫",
        "symbol": "VND"
      },
      "VUV": {
        "displayName": {
          "other": "ვანატუს ვატუ"
        },
        "narrow": "VUV",
        "symbol": "VUV"
      },
      "WST": {
        "displayName": {
          "one": "დასავლეთ სამოას ტალა",
          "other": "სამოური ტალა"
        },
        "narrow": "WST",
        "symbol": "WST"
      },
      "XAF": {
        "displayName": {
          "other": "ცენტრალურ აფრიკული CFA ფრანკი"
        },
        "narrow": "FCFA",
        "symbol": "FCFA"
      },
      "XAG": {
        "displayName": {
          "other": "ვერცხლი"
        },
        "narrow": "XAG",
        "symbol": "XAG"
      },
      "XBA": {
        "displayName": {
          "other": "ევროპული კომპპოზიტური ერთეული"
        },
        "narrow": "XBA",
        "symbol": "XBA"
      },
      "XBB": {
        "displayName": {
          "other": "ევროპული ფულადი ერთეული"
        },
        "narrow": "XBB",
        "symbol": "XBB"
      },
      "XCD": {
        "displayName": {
          "other": "აღმოსავლეთ კარიბიული დოლარი"
        },
        "narrow": "$",
        "symbol": "EC$"
      },
      "XEU": {
        "displayName": {
          "other": "ევროპული სავალუტო ერთეული"
        },
        "narrow": "XEU",
        "symbol": "XEU"
      },
      "XFO": {
        "displayName": {
          "other": "ფრანგული ოქროს ფრანკი"
        },
        "narrow": "XFO",
        "symbol": "XFO"
      },
      "XOF": {
        "displayName": {
          "other": "დასავლეთ აფრიკული CFA ფრანკი"
        },
        "narrow": "F CFA",
        "symbol": "F CFA"
      },
      "XPF": {
        "displayName": {
          "other": "CFP ფრანკი"
        },
        "narrow": "CFPF",
        "symbol": "CFPF"
      },
      "XXX": {
        "displayName": {
          "one": "(ვალუტის უცნობი ერთეული)",
          "other": "(უცნობი ვალუტა)"
        },
        "narrow": "¤",
        "symbol": "¤"
      },
      "YDD": {
        "displayName": {
          "other": "იემენის დინარი"
        },
        "narrow": "YDD",
        "symbol": "YDD"
      },
      "YER": {
        "displayName": {
          "other": "იემენის რეალი"
        },
        "narrow": "YER",
        "symbol": "YER"
      },
      "YUD": {
        "displayName": {
          "other": "იუგოსლავიური მყარი დინარი"
        },
        "narrow": "YUD",
        "symbol": "YUD"
      },
      "YUM": {
        "displayName": {
          "other": "იუგოსლავიური ახალი დინარი"
        },
        "narrow": "YUM",
        "symbol": "YUM"
      },
      "YUN": {
        "displayName": {
          "other": "იუგოსლავიური კონვერტირებადი დინარი"
        },
        "narrow": "YUN",
        "symbol": "YUN"
      },
      "ZAR": {
        "displayName": {
          "other": "სამხრეთ აფრიკული რანდი"
        },
        "narrow": "R",
        "symbol": "ZAR"
      },
      "ZMK": {
        "displayName": {
          "other": "ზამბიური კვაჭა (1968–2012)"
        },
        "narrow": "ZMK",
        "symbol": "ZMK"
      },
      "ZMW": {
        "displayName": {
          "other": "ზამბიური კვაჭა"
        },
        "narrow": "ZK",
        "symbol": "ZMW"
      },
      "ZRN": {
        "displayName": {
          "other": "ზაირის ახალი ზაირი"
        },
        "narrow": "ZRN",
        "symbol": "ZRN"
      },
      "ZRZ": {
        "displayName": {
          "other": "ზაირის ზაირი"
        },
        "narrow": "ZRZ",
        "symbol": "ZRZ"
      },
      "ZWD": {
        "displayName": {
          "other": "ზიმბაბვეს დოლარი"
        },
        "narrow": "ZWD",
        "symbol": "ZWD"
      }
    },
    "nu": [
      "latn"
    ],
    "numbers": {
      "currency": {
        "latn": {
          "accounting": "#,##0.00 ¤",
          "currencySpacing": {
            "afterInsertBetween": " ",
            "beforeInsertBetween": " "
          },
          "short": {
            "1000": {
              "other": "0 ათ'.' ¤"
            },
            "10000": {
              "other": "00 ათ'.' ¤"
            },
            "100000": {
              "other": "000 ათ'.' ¤"
            },
            "1000000": {
              "other": "0 მლნ'.' ¤"
            },
            "10000000": {
              "other": "00 მლნ'.' ¤"
            },
            "100000000": {
              "other": "000 მლნ'.' ¤"
            },
            "1000000000": {
              "other": "0 მლრდ'.' ¤"
            },
            "10000000000": {
              "other": "00 მლრდ'.' ¤"
            },
            "100000000000": {
              "other": "000 მლრ'.' ¤"
            },
            "1000000000000": {
              "other": "0 ტრლ'.' ¤"
            },
            "10000000000000": {
              "other": "00 ტრლ'.' ¤"
            },
            "100000000000000": {
              "other": "000 ტრლ'.' ¤"
            }
          },
          "standard": "#,##0.00 ¤",
          "unitPattern": "{0} {1}"
        }
      },
      "decimal": {
        "latn": {
          "long": {
            "1000": {
              "other": "0 ათასი"
            },
            "10000": {
              "other": "00 ათასი"
            },
            "100000": {
              "other": "000 ათასი"
            },
            "1000000": {
              "other": "0 მილიონი"
            },
            "10000000": {
              "other": "00 მილიონი"
            },
            "100000000": {
              "other": "000 მილიონი"
            },
            "1000000000": {
              "other": "0 მილიარდი"
            },
            "10000000000": {
              "other": "00 მილიარდი"
            },
            "100000000000": {
              "other": "000 მილიარდი"
            },
            "1000000000000": {
              "other": "0 ტრილიონი"
            },
            "10000000000000": {
              "other": "00 ტრილიონი"
            },
            "100000000000000": {
              "other": "000 ტრილიონი"
            }
          },
          "short": {
            "1000": {
              "other": "0 ათ'.'"
            },
            "10000": {
              "other": "00 ათ'.'"
            },
            "100000": {
              "other": "000 ათ'.'"
            },
            "1000000": {
              "other": "0 მლნ'.'"
            },
            "10000000": {
              "other": "00 მლნ'.'"
            },
            "100000000": {
              "other": "000 მლნ'.'"
            },
            "1000000000": {
              "other": "0 მლრდ'.'"
            },
            "10000000000": {
              "other": "00 მლრდ'.'"
            },
            "100000000000": {
              "other": "000 მლრ'.'"
            },
            "1000000000000": {
              "other": "0 ტრლ'.'"
            },
            "10000000000000": {
              "other": "00 ტრლ'.'"
            },
            "100000000000000": {
              "other": "000 ტრლ'.'"
            }
          },
          "standard": "#,##0.###"
        }
      },
      "nu": [
        "latn"
      ],
      "percent": {
        "latn": "#,##0%"
      },
      "symbols": {
        "latn": {
          "approximatelySign": "≈",
          "decimal": ",",
          "exponential": "E",
          "group": " ",
          "infinity": "∞",
          "list": ";",
          "minusSign": "-",
          "nan": "არ არის რიცხვი",
          "perMille": "‰",
          "percentSign": "%",
          "plusSign": "+",
          "rangeSign": "-",
          "superscriptingExponent": "×",
          "timeSeparator": ":"
        }
      }
    },
    "units": {
      "compound": {
        "per": {
          "long": "{0}/{1}",
          "narrow": "{0}/{1}",
          "short": "{0}/{1}"
        }
      },
      "simple": {
        "acre": {
          "long": {
            "other": "{0} აკრი"
          },
          "narrow": {
            "other": "{0} აკრი"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} აკრი"
          }
        },
        "bit": {
          "long": {
            "other": "{0} ბიტი"
          },
          "narrow": {
            "other": "{0} ბიტი"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} ბიტი"
          }
        },
        "byte": {
          "long": {
            "other": "{0} ბაიტი"
          },
          "narrow": {
            "other": "{0} ბაიტი"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} ბაიტი"
          }
        },
        "celsius": {
          "long": {
            "other": "{0} გრადუსი ცელსიუსით"
          },
          "narrow": {
            "other": "{0}°C"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0}°C"
          }
        },
        "centimeter": {
          "long": {
            "other": "{0} სანტიმეტრი"
          },
          "narrow": {
            "other": "{0} სმ"
          },
          "perUnit": {
            "long": "{0} სანტიმეტრში",
            "narrow": "{0}/სმ",
            "short": "{0}/სმ"
          },
          "short": {
            "other": "{0} სმ"
          }
        },
        "day": {
          "long": {
            "other": "{0} დღე"
          },
          "narrow": {
            "other": "{0} დღე"
          },
          "perUnit": {
            "long": "{0} დღეში",
            "narrow": "{0}/დღე",
            "short": "{0}/დღე"
          },
          "short": {
            "other": "{0} დღე"
          }
        },
        "degree": {
          "long": {
            "other": "{0} გრადუსი"
          },
          "narrow": {
            "other": "{0}°"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0}°"
          }
        },
        "fahrenheit": {
          "long": {
            "other": "{0} გრადუსი ფარენჰეიტით"
          },
          "narrow": {
            "other": "{0}°F"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0}°F"
          }
        },
        "fluid-ounce": {
          "long": {
            "other": "{0} თხევადი უნცია"
          },
          "narrow": {
            "other": "{0} თხ. უნცია"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} თხ. უნცია"
          }
        },
        "foot": {
          "long": {
            "other": "{0} ფუტი"
          },
          "narrow": {
            "other": "{0} ფტ"
          },
          "perUnit": {
            "long": "{0} ფუტში",
            "narrow": "{0}/ფტ",
            "short": "{0}/ფტ"
          },
          "short": {
            "other": "{0} ფტ"
          }
        },
        "gallon": {
          "long": {
            "other": "{0} გალონი"
          },
          "narrow": {
            "other": "{0} გალონი"
          },
          "perUnit": {
            "long": "{0} გალონში",
            "narrow": "{0}/გალონი",
            "short": "{0}/გალონი"
          },
          "short": {
            "other": "{0} გალონი"
          }
        },
        "gigabit": {
          "long": {
            "other": "{0} გიგაბიტი"
          },
          "narrow": {
            "other": "{0} გბიტი"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} გბიტი"
          }
        },
        "gigabyte": {
          "long": {
            "other": "{0} გიგაბაიტი"
          },
          "narrow": {
            "other": "{0} GB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} GB"
          }
        },
        "gram": {
          "long": {
            "other": "{0} გრამი"
          },
          "narrow": {
            "other": "{0}გ"
          },
          "perUnit": {
            "long": "{0} გრამში",
            "narrow": "{0}/გ",
            "short": "{0}/გ"
          },
          "short": {
            "other": "{0} გ"
          }
        },
        "hectare": {
          "long": {
            "other": "{0} ჰექტარი"
          },
          "narrow": {
            "other": "{0} ჰა"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} ჰა"
          }
        },
        "hour": {
          "long": {
            "other": "{0} საათი"
          },
          "narrow": {
            "other": "{0}სთ"
          },
          "perUnit": {
            "long": "{0} საათში",
            "narrow": "{0}/სთ",
            "short": "{0}/სთ"
          },
          "short": {
            "other": "{0} სთ"
          }
        },
        "inch": {
          "long": {
            "other": "{0} დუიმი"
          },
          "narrow": {
            "other": "{0} დმ"
          },
          "perUnit": {
            "long": "{0} დუიმში",
            "narrow": "{0}/დუიმი",
            "short": "{0}/დუიმი"
          },
          "short": {
            "other": "{0} დუიმი"
          }
        },
        "kilobit": {
          "long": {
            "other": "{0} კილობიტი"
          },
          "narrow": {
            "other": "{0} კბიტი"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} კბიტი"
          }
        },
        "kilobyte": {
          "long": {
            "other": "{0} კილობაიტი"
          },
          "narrow": {
            "other": "{0} კბაიტი"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} კბაიტი"
          }
        },
        "kilogram": {
          "long": {
            "other": "{0} კილოგრამი"
          },
          "narrow": {
            "other": "{0}კგ"
          },
          "perUnit": {
            "long": "{0} კილოგრამში",
            "narrow": "{0}/კგ",
            "short": "{0}/კგ"
          },
          "short": {
            "other": "{0} კგ"
          }
        },
        "kilometer": {
          "long": {
            "other": "{0} კილომეტრი"
          },
          "narrow": {
            "other": "{0} კმ"
          },
          "perUnit": {
            "long": "{0} კილომეტრში",
            "narrow": "{0}/კმ",
            "short": "{0}/კმ"
          },
          "short": {
            "other": "{0} კმ"
          }
        },
        "kilometer-per-hour": {
          "long": {
            "other": "{0} კილომეტრი საათში"
          },
          "narrow": {
            "other": "{0} კმ/სთ"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} კმ/სთ"
          }
        },
        "liter": {
          "long": {
            "other": "{0} ლიტრი"
          },
          "narrow": {
            "other": "{0}ლ"
          },
          "perUnit": {
            "long": "{0} ლიტრში",
            "narrow": "{0}/ლ",
            "short": "{0}/ლ"
          },
          "short": {
            "other": "{0} ლ"
          }
        },
        "liter-per-kilometer": {
          "long": {
            "other": "{0} ლიტრი კილომეტრზე"
          },
          "narrow": {
            "other": "{0} ლ/კმ"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} ლ/კმ"
          }
        },
        "megabit": {
          "long": {
            "other": "{0} მეგაბიტი"
          },
          "narrow": {
            "other": "{0} მბიტი"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} მბიტი"
          }
        },
        "megabyte": {
          "long": {
            "other": "{0} მეგაბაიტი"
          },
          "narrow": {
            "other": "{0} MB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} MB"
          }
        },
        "meter": {
          "long": {
            "other": "{0} მეტრი"
          },
          "narrow": {
            "other": "{0}მ"
          },
          "perUnit": {
            "long": "{0} მეტრში",
            "narrow": "{0}/მ",
            "short": "{0}/მ"
          },
          "short": {
            "other": "{0} მ"
          }
        },
        "meter-per-second": {
          "long": {
            "other": "{0} მეტრი წამში"
          },
          "narrow": {
            "other": "{0} მ/წმ"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} მ/წმ"
          }
        },
        "mile": {
          "long": {
            "other": "{0} მილი"
          },
          "narrow": {
            "other": "{0} მილი"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} მილი"
          }
        },
        "mile-per-gallon": {
          "long": {
            "other": "{0} მილი გალონზე"
          },
          "narrow": {
            "other": "{0} მილი/გალ."
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} მილი/გალ."
          }
        },
        "mile-per-hour": {
          "long": {
            "other": "{0} მილი საათში"
          },
          "narrow": {
            "other": "{0} მილი/სთ"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} მილი/სთ"
          }
        },
        "mile-scandinavian": {
          "long": {
            "other": "{0} სკანდინავიური მილი"
          },
          "narrow": {
            "other": "{0} სკანდ. მილი"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} სკანდ. მილი"
          }
        },
        "milliliter": {
          "long": {
            "other": "{0} მილილიტრი"
          },
          "narrow": {
            "other": "{0} მილილ."
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} მილილ."
          }
        },
        "millimeter": {
          "long": {
            "other": "{0} მილიმეტრი"
          },
          "narrow": {
            "other": "{0} მმ"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} მმ"
          }
        },
        "millisecond": {
          "long": {
            "other": "{0} მილიწამი"
          },
          "narrow": {
            "other": "{0} მწმ"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} მწმ"
          }
        },
        "minute": {
          "long": {
            "other": "{0} წუთი"
          },
          "narrow": {
            "other": "{0}წთ"
          },
          "perUnit": {
            "long": "{0} წუთში",
            "narrow": "{0}/წთ",
            "short": "{0}/წთ"
          },
          "short": {
            "other": "{0} წთ"
          }
        },
        "month": {
          "long": {
            "other": "{0} თვე"
          },
          "narrow": {
            "other": "{0} თვე"
          },
          "perUnit": {
            "long": "{0} თვეში",
            "narrow": "{0}/თ.",
            "short": "{0}/თვე"
          },
          "short": {
            "other": "{0} თვე"
          }
        },
        "ounce": {
          "long": {
            "other": "{0} უნცია"
          },
          "narrow": {
            "other": "{0} უნც"
          },
          "perUnit": {
            "long": "{0} უნციაში",
            "narrow": "{0}/უნც",
            "short": "{0}/უნც"
          },
          "short": {
            "other": "{0} უნც"
          }
        },
        "percent": {
          "long": {
            "other": "{0} პროცენტი"
          },
          "narrow": {
            "other": "{0}%"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0}%"
          }
        },
        "petabyte": {
          "long": {
            "one": "{0} პბაიტი",
            "other": "{0} პეტაბაიტი"
          },
          "narrow": {
            "other": "{0} პბაიტი"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} პბაიტი"
          }
        },
        "pound": {
          "long": {
            "other": "{0} ფუნტი"
          },
          "narrow": {
            "other": "{0} ფნტ"
          },
          "perUnit": {
            "long": "{0} ფუნტში",
            "narrow": "{0}/ფნტ",
            "short": "{0}/ფნტ"
          },
          "short": {
            "other": "{0} ფნტ"
          }
        },
        "second": {
          "long": {
            "other": "{0} წამი"
          },
          "narrow": {
            "other": "{0}წმ"
          },
          "perUnit": {
            "long": "{0} წამში",
            "narrow": "{0}/წმ",
            "short": "{0}/წმ"
          },
          "short": {
            "other": "{0} წმ"
          }
        },
        "stone": {
          "long": {
            "other": "{0} სტოუნი"
          },
          "narrow": {
            "other": "{0} სტოუნი"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} სტოუნი"
          }
        },
        "terabit": {
          "long": {
            "other": "{0} ტერაბიტი"
          },
          "narrow": {
            "other": "{0} ტბიტი"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} ტბიტი"
          }
        },
        "terabyte": {
          "long": {
            "other": "{0} ტერაბაიტი"
          },
          "narrow": {
            "other": "{0} ტბაიტი"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} ტბაიტი"
          }
        },
        "week": {
          "long": {
            "other": "{0} კვირა"
          },
          "narrow": {
            "other": "{0} კვრ"
          },
          "perUnit": {
            "long": "{0} კვირაში",
            "narrow": "{0}/კვრ",
            "short": "{0}/კვრ"
          },
          "short": {
            "other": "{0} კვრ"
          }
        },
        "yard": {
          "long": {
            "other": "{0} იარდი"
          },
          "narrow": {
            "other": "{0} იარდი"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} იარდი"
          }
        },
        "year": {
          "long": {
            "other": "{0} წელი"
          },
          "narrow": {
            "other": "{0} წ"
          },
          "perUnit": {
            "long": "{0} წელში",
            "narrow": "{0}/წ",
            "short": "{0}/წ"
          },
          "short": {
            "other": "{0} წ"
          }
        }
      }
    }
  },
  "locale": "ka"
})
}